import { render, staticRenderFns } from "./applyForCheck.vue?vue&type=template&id=72006d3c&scoped=true"
import script from "./applyForCheck.vue?vue&type=script&lang=js"
export * from "./applyForCheck.vue?vue&type=script&lang=js"
import style0 from "./applyForCheck.vue?vue&type=style&index=0&id=72006d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72006d3c",
  null
  
)

export default component.exports